import Swiper from 'swiper';
import { Navigation, Autoplay, EffectFade, Keyboard } from 'swiper/modules';
const initPhotosSlider = (element) => {
    const sliderElement = element.querySelector('.photos-slider__slider');
    if (!sliderElement)
        return;
    sliderElement.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        var _a;
        const preloader = document.createElement('div');
        preloader.classList.add('swiper-lazy-preloader');
        preloader.classList.add('swiper-lazy-preloader-white');
        (_a = img.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(preloader);
    });
    const btnPrev = (element === null || element === void 0 ? void 0 : element.querySelector('.photos-slider__prev')) || null;
    const btnNext = (element === null || element === void 0 ? void 0 : element.querySelector('.photos-slider__next')) || null;
    const options = {
        modules: [Navigation, Autoplay, EffectFade, Keyboard],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        speed: 500,
        navigation: {
            prevEl: btnPrev,
            nextEl: btnNext,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
    };
    const autoplayDelay = element.hasAttribute('data-autoplay')
        ? +(element.getAttribute('data-autoplay') || 5000)
        : 0;
    if (autoplayDelay) {
        options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        };
    }
    const swiper = new Swiper(sliderElement, options);
    element.swiper = swiper;
};
document.querySelectorAll('.photos-slider').forEach((element) => {
    initPhotosSlider(element);
});
